"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
function hotjar() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // https://help.hotjar.com/hc/en-us/articles/115015712548-Using-JavaScript-Triggers-to-Start-Recordings#example
    window.hj =
        window.hj ||
            function () {
                (hj.q = hj.q || []).push(arguments);
            };
    window.hj.apply(window, args);
}
exports.default = hotjar;
//# sourceMappingURL=hotjar.js.map